import { AdFormat, DeviceType } from '../types';

import { getDevice } from './getDevice';

/**
 * Returns a complete {@link InventoryCode}, based on the given template and parameters.
 *
 * @param invCodeTemplate - `${section}`, `${device}`, `${format}` will be replaced with valid values
 * @param {AdFormat} format
 * @param deviceType
 * @param section
 * @param useAFP - whether AFP (Ad Financed Production) placement should be used
 * @param options - optional configuration for section handling
 *
 * @return {InventoryCode}
 *
 * @see {@link https://docs.google.com/spreadsheets/d/1ejKO4uIZBCaQrTX8rOfdriouKYLFrdk1EG2Cml0UOFY/edit#gid=0|AB placements}
 */
function getInvCode(
  invCodeTemplate: string,
  format: AdFormat,
  deviceType: DeviceType,
  section?: string,
  useAFP = false,
  options?: {
    knownSections?: string[];
    omitUnknownSection?: boolean;
    defaultSection?: string;
  }
) {
  const sections = options?.knownSections;
  const sectionValue =
    section && (!sections || sections.includes(section)) ? section : null;
  let finalSection = useAFP
    ? 'afp'
    : sectionValue || options?.defaultSection || 'other';
  const device = getDevice(deviceType);

  // this is a temporary change, until instream (preroll, midroll) ads setup is aligned as well
  // see vgtv/frontend#340 for details
  if (format === 'pause') {
    if (useAFP) {
      finalSection = 'afp';
    }
  }

  // Strip section placeholder when omitUnknownSection is enabled and no valid section is available
  if (options?.omitUnknownSection && !sectionValue && !useAFP) {
    invCodeTemplate = invCodeTemplate.replace(/[_-]\$\{section\}/, '');
  }

  return invCodeTemplate
    .replace('${section}', finalSection)
    .replace('${device}', device)
    .replace('${format}', format);
}

export { getInvCode };
